import React, { useState, useEffect } from 'react';
import style from '../css/BoookingData.module.css';
import { FaCircleCheck, FaInfo, FaX } from 'react-icons/fa6';
import { FaArrowAltCircleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function BoookingData() {
	const [open, setOpen] = useState(false);
	const [bookingID, setBookingID] = useState('');
	const [bookingData, setBookingData] = useState(null);
	const [agentData, setAgentData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	const fetchBookingDetails = async () => {
		if (!bookingID) {
			setError('Please enter a booking ID');
			return;
		}
		setLoading(true);
		setError('');
		try {
			const response = await fetch(
				`https://hometech-repairs.in/homeTech/FetchBooking.php?order_number=${bookingID}`
			);
			const result = await response.json();
			if (result.status) {
				setBookingData(result.data);
			} else {
				setError(result.msg);
			}
		} catch (err) {
			setError('Failed to fetch booking details');
		}
		setLoading(false);
	};

	useEffect(() => {
		if (bookingData?.agent_id) {
			const fetchAgentDetails = async () => {
				try {
					const response = await fetch(
						`https://hometech-repairs.in/homeTech/FetchAgent.php?id=${bookingData.agent_id}`
					);
					const result = await response.json();
					if (result.status) {
						setAgentData(result.data);
					} else {
						setAgentData(null);
					}
				} catch (err) {
					console.error('Error fetching agent details:', err);
					setAgentData(null);
				}
			};

			fetchAgentDetails();
		} else {
			setAgentData(null);
		}
	}, [bookingData]);

	return (
		<div className={style.container}>
			{!open ? (
				<div className={style.div1} onClick={() => setOpen(true)}>
					<FaInfo size={20} color={'green'} />
					<p>My Bookings</p>
				</div>
			) : (
				<div className={style.modal}>
					<div className={style.header}>
						<p>Booking Details</p>
						<div onClick={() => setOpen(false)}>
							<FaX size={20} color="white" />
						</div>
					</div>

					<div className={style.body}>
						{error && <p className={style.error}>{error}</p>}
						{loading ? (
							<p>Loading...</p>
						) : bookingData ? (
							<div>
								{bookingData.status === 'Cancelled' ? (
									<div className={style.cancelledBox}>
										<p className={style.date}>
											{new Date(bookingData.date).toLocaleDateString('en-GB')}
										</p>

										<p className={style.orNbr}>{bookingData.order_number}</p>
										<div className={style.rows}>
											<FaCircleCheck color="red" />
											<p>Service Cancelled</p>
										</div>
									</div>
								) : (
									<div>
										<p className={style.date}>
											{new Date(bookingData.date).toLocaleDateString('en-GB')}
										</p>

										<p className={style.orNbr}>{bookingData.order_number}</p>
										<div className={style.rows}>
											<FaCircleCheck color="green" />
											<p>Booking Created</p>
										</div>
										<div className={style.side}>
											<p>Name: {bookingData.name}</p>
											<p>
												Phone:
												{bookingData.phone
													? ` ****${bookingData.phone.slice(-4)}`
													: 'Not Available'}
											</p>
										</div>

										<div className={style.rows}>
											<FaCircleCheck
												color={
													bookingData.status === 'Created'
														? 'orange'
														: bookingData.status === 'Accepted'
														? 'green'
														: bookingData.status === 'Work in progress'
														? 'green'
														: bookingData.status === 'Completed'
														? 'green'
														: 'orange'
												}
											/>
											<p>
												{bookingData.status === 'Created'
													? 'Waiting to accept'
													: 'Accepted'}
											</p>
										</div>

										<div className={style.side}>
											{agentData && (
												<div className={style.agentDetails}>
													<p>Name: {agentData.name}</p>
													<p>Phone: {agentData.phone}</p>
													<p>ID: {agentData.agent_id}</p>
												</div>
											)}
										</div>

										<div className={style.rows}>
											<FaCircleCheck
												color={
													bookingData.status === 'Work in progress'
														? 'green'
														: 'orange'
												}
											/>
											<p>Work in progress</p>
										</div>

										<div className={style.rows}>
											<FaCircleCheck
												color={
													bookingData.status === 'Completed'
														? 'green'
														: 'orange'
												}
											/>
											<p>Completed</p>
										</div>

										{bookingData.status === 'Completed' && (
											<Link
												className={style.invoice}
												to={`/invoice/${bookingData.order_number}`}
												onClick={() => setOpen(false)}
											>
												View Invoice
											</Link>
										)}
									</div>
								)}
							</div>
						) : null}

						<div>
							<p
								className={style.txt}
								onClick={() => {
									setOpen(false);
								}}
							>
								<Link
									to={'https://customer.hometech-repairs.in/'}
									className={style.btnBook}
								>
									Login
								</Link>
							</p>
							<p style={{ textAlign: 'center', marginTop: 5, marginBottom: 5 }}>
								Or
							</p>
							<p
								className={style.txt}
								onClick={() => {
									setOpen(false);
								}}
							>
								<Link to={'/contact-us'} className={style.btnBook}>
									Book Appointment
								</Link>
							</p>
						</div>

						<div className={style.inputDiv}>
							<input
								type="text"
								placeholder="Enter your Booking ID"
								className={style.input}
								value={bookingID}
								onChange={(e) => setBookingID(e.target.value)}
							/>
							<div onClick={fetchBookingDetails}>
								<FaArrowAltCircleRight size={20} />
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default BoookingData;
